/*--------------------------------------------------------------
# Custom scripts for Related post type block
--------------------------------------------------------------*/

const cardSlider = document.querySelectorAll('.post-feed-slider .swiper');
const cardSliderPagination = document.querySelectorAll('.card-swiper-pagination');
const cardSliderNext = document.querySelectorAll('.card-swiper-next');
const cardSliderPrev = document.querySelectorAll('.card-swiper-prev');

for( i = 0; i < cardSlider.length; i++ ) {
    // loop through every example of the slider and add a dynamic class
    // then init slider, pagination and nav arrows based on that new dynamic class
    cardSlider[i].classList.add('swiper-' + i);
    cardSliderNext[i].classList.add('card-swiper-next-' + i);
    cardSliderPrev[i].classList.add('card-swiper-prev-' + i);

    var initCardSlider = new Swiper('.post-feed-slider .swiper-' + i, {
        simulateTouch: false,
        grabCursor: false,
        slidesPerView: 1.1,
        spaceBetween: 24,
        // Navigation arrows
        navigation: {
            nextEl: '.card-swiper-next-' + i,
            prevEl: '.card-swiper-prev-' + i,
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            }
        }
    });
}
